(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-vzk"] && !Shopify.designMode) return;
  try {
    if (!window.__vzkProductCardHoverCalcBound) {
    window.__vzkProductCardHoverCalcBound = true;

    const calculateHoverCeiling = (card) => {
      if (!card.classList.contains('vzk-product-card--layered')) return;
      if (card.dataset.customHoverLift === 'true') return;

      const img = card.querySelector('.vzk-product-card__image');
      const media = card.querySelector('.vzk-product-card__media');
      if (!img || !media) return;

      const imgHeight = img.naturalHeight || img.offsetHeight || 1;
      const imgWidth = img.naturalWidth || img.offsetWidth || 1;
      const mediaHeight = media.offsetHeight || media.clientHeight || 0;
      const mediaWidth = media.offsetWidth || media.clientWidth || 0;

      if (!mediaHeight || !mediaWidth) return;

      const innerW = mediaWidth * 0.84;
      const innerH = mediaHeight * 0.88;
      const ratio = imgWidth / imgHeight;

      let renderedH = innerH;
      let renderedW = renderedH * ratio;
      if (renderedW > innerW) {
        renderedW = innerW;
        renderedH = renderedW / ratio;
      }

      const topPad = mediaHeight * 0.08;
      const unusedH = innerH - renderedH;
      const actualTopOffset = topPad + unusedH / 2;

      const maxProtrusion = Math.min(6, mediaHeight * 0.02);
      const maxLiftPx = Math.max(0, actualTopOffset + maxProtrusion);

      const targetLiftPx = 0;
      const finalLiftPx = Math.min(targetLiftPx, maxLiftPx);
      const liftPercent = (finalLiftPx / mediaHeight) * 100;

      card.style.setProperty('--vzk-product-hover-lift', `-${liftPercent.toFixed(1)}%`);
    };

    const updateAllCards = () => {
      document.querySelectorAll('.vzk-product-card--layered').forEach((card) => {
        const img = card.querySelector('.vzk-product-card__image');
        if (img) {
          if (img.complete) {
            calculateHoverCeiling(card);
          } else {
            img.addEventListener('load', () => calculateHoverCeiling(card), { once: true });
          }
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAllCards);
    } else {
      updateAllCards();
    }

    let resizeTimer;
    window.addEventListener(
      'resize',
      () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateAllCards, 150);
      },
      { passive: true }
    );

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.classList?.contains('vzk-product-card--layered')) {
              calculateHoverCeiling(node);
            } else {
              node.querySelectorAll?.('.vzk-product-card--layered').forEach(calculateHoverCeiling);
            }
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (!window.__vzkProductCardClickBound) {
    window.__vzkProductCardClickBound = true;
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented) return;
      const card = event.target.closest('.vzk-product-card[data-product-url]');
      if (!card) return;
      if (event.target.closest('.vzk-product-card__form, button, input, textarea, select, a')) return;
      const url = card.dataset.productUrl;
      if (url) {
        window.location.href = url;
      }
    });
  }

  if (!window.__vzkProductCardQuickAddBound) {
    window.__vzkProductCardQuickAddBound = true;

    const playCardCartMotion = (button) => {
      if (!button) return;
      if (button._isPlayingMotion) return;
      button._isPlayingMotion = true;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        button.dataset.cartMotionStage = '3';
        button._isPlayingMotion = false;
        return;
      }

      if (button._motionTimers) {
        button._motionTimers.forEach(clearTimeout);
      }
      button._motionTimers = [];

      button.dataset.cartMotionStage = '0';

      const schedule = (stage, delay) => {
        button._motionTimers.push(
          setTimeout(() => {
            button.dataset.cartMotionStage = String(stage);
          }, delay)
        );
      };

      schedule(1, 80);
      schedule(2, 280);
      schedule(3, 520);
      button._motionTimers.push(
        setTimeout(() => {
          delete button.dataset.cartMotionStage;
          button._isPlayingMotion = false;
          button._motionTimers = [];
        }, 750)
      );
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.vzk-product-card__quick-add');
      if (!button || button.disabled || button.classList.contains('is-loading')) return;
      playCardCartMotion(button);
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.vzk-product-card__form');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();

      const button = form.querySelector('.vzk-product-card__quick-add');
      if (!button || button.disabled || button.classList.contains('is-loading')) return;

      playCardCartMotion(button);

      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);

      button.classList.add('is-loading');
      const drawer = document.querySelector('cart-drawer');
      drawer?.setActiveElement(button);

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: quantity,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.description || 'Erro ao adicionar ao carrinho');
        }

        const item = await response.json();
        if (drawer) {
          if (!item.sections?.['cart-drawer']) {
            const sectionsUrl = new URL(window.location.href);
            sectionsUrl.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
            const sectionsResponse = await fetch(sectionsUrl, { cache: 'no-store' });
            if (!sectionsResponse.ok) throw new Error('Não foi possível atualizar o carrinho.');
            item.sections = await sectionsResponse.json();
          }
          drawer.renderContents(item);
        }
        button.classList.remove('is-loading');

        try {
          const cartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
          if (cartRes.ok) {
            const cart = await cartRes.json();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, item } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart, item } }));
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, item } }));
          }
        } catch (bubbleErr) {}
      } catch (err) {
        console.error('Quick add error:', err);
        button.classList.remove('is-loading');
      }
    });
  }

if (!window.__vzkProductCardTouchHoverBound) {
  window.__vzkProductCardTouchHoverBound = true;

  let touchTimer;
  let activeCard = null;
  let longPress = false;


  document.addEventListener('touchstart', function(event) {
    const card = event.target.closest('.vzk-product-card--layered');

    if (!card) return;

    longPress = false;

    touchTimer = setTimeout(() => {

      longPress = true;

    if (activeCard && activeCard !== card) {
      activeCard.classList.remove(
        'is-touch-hover',
        'is-touch-ready'
      );
    }

      card.classList.add('is-touch-hover');

      const slide = card.closest('.yafa-ProductSlider__slide');

    if (slide) {
      document
        .querySelectorAll('.yafa-ProductSlider__slide.is-touch-selected')
        .forEach(item => item.classList.remove('is-touch-selected'));

      document
        .querySelectorAll('.yafa-ProductSlider__slide.is-active')
        .forEach(item => {
          item.classList.remove('is-active');
        });

      slide.classList.add('is-touch-selected');
    }

      requestAnimationFrame(() => {
        card.classList.add('is-touch-ready');
      });

      activeCard = card;

    }, 300);

  }, { passive: true });


  document.addEventListener('touchend', function(event) {

    clearTimeout(touchTimer);

    if (longPress) {
      event.preventDefault();

      return;
    }

  }, { passive: false });


  document.addEventListener('touchcancel', function() {

    clearTimeout(touchTimer);

  }, { passive: true });


  document.addEventListener('click', function(event) {

    if (longPress) {
      event.preventDefault();
      event.stopPropagation();

      longPress = false;
    }

  }, true);

}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yafa-mobile-search-vzk')) {
    customElements.define(
      'yafa-mobile-search-vzk',
      class extends HTMLElement {
        connectedCallback() {
          if (this.parentElement !== document.body) {
            document.body.appendChild(this);
            return;
          }

          this.input = this.querySelector('[data-mobile-search-input]');
          this.products = this.querySelector('[data-mobile-search-products]');
          this.dots = this.querySelector('[data-mobile-search-dots]');
          this.status = this.querySelector('[data-mobile-search-status]');
          this.titleEl = this.querySelector('.yafa-mobile-search__featured .yafa-mobile-search__heading-label > span');
          if (!this.input || !this.products || !this.dots) return;

          this.initialMarkup = this.products.innerHTML;
          this.cache = new Map();
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };

          this.input.addEventListener('input', () => this.onInput(), options);
          this.querySelector('.yafa-mobile-search__form')?.addEventListener('submit', (e) => {
            e.preventDefault();
            window.clearTimeout(this.timer);
            const term = this.input.value.trim();
            if (!term) {
              this.resetResults();
              return;
            }
            this.updateActiveCategoryByTerm(term);
            this.loadResults(term);
          }, options);
          this.products.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(this.scrollFrame);
              this.scrollFrame = requestAnimationFrame(() => this.updateDots());
            },
            { passive: true, signal: this.abort.signal }
          );
          this.querySelector('.yafa-mobile-search__categories')?.addEventListener(
            'click',
            (event) => this.onSuggestion(event),
            options
          );
          this.querySelectorAll('.rgd-mobile-search-close').forEach((button) => {
            button.addEventListener(
              'click',
              () => {
                this.input.value = '';
                this.resetResults();
              },
              options
            );
          });

          this.visibilityObserver = new MutationObserver(() => {
            if (this.getAttribute('aria-hidden') === 'false') {
              this.updatePosition();
              this.buildDots();
            }
          });
          this.visibilityObserver.observe(this, { attributes: true, attributeFilter: ['aria-hidden'] });
          window.addEventListener(
            'resize',
            () => {
              if (this.getAttribute('aria-hidden') === 'false') this.updatePosition();
              this.buildDots();
            },
            options
          );
        }

        updatePosition() {
          const header = document.querySelector('.container-header, header, .header-wrapper, sticky-header, [id^="shopify-section-header"]');
          const bottom = header?.getBoundingClientRect().bottom || 0;
          const top = Math.max(0, bottom);
          document.documentElement.style.setProperty('--yafa-search-drawer-top', `${top}px`);
        }

        onSuggestion(event) {
          const category = event.target.closest('[data-search-term]');
          if (!category) return;
          const link = category.dataset.searchLink;
          if (link) {
            window.location.assign(link);
            return;
          }
          const button = category.querySelector('.yafa-category__item');
          this.setActiveCategory(button);
          this.input.value = category.dataset.searchTerm || '';
          this.input.focus();
          this.onInput();
        }

        setActiveCategory(activeButton) {
          this.querySelectorAll('.yafa-mobile-search__category .yafa-category__item').forEach((btn) => {
            const isActive = btn === activeButton;
            btn.classList.toggle('yafa-category__item--filled', isActive);
            btn.classList.toggle('yafa-category__item--dotted', !isActive);
            btn.setAttribute('aria-pressed', String(isActive));
          });
        }

        updateActiveCategoryByTerm(term) {
          const lowerTerm = term.toLowerCase();
          this.querySelectorAll('.yafa-mobile-search__category').forEach((cat) => {
            const btn = cat.querySelector('.yafa-category__item');
            if (!btn) return;
            const catTerm = (cat.dataset.searchTerm || '').toLowerCase();
            const isActive = catTerm === lowerTerm;
            btn.classList.toggle('yafa-category__item--filled', isActive);
            btn.classList.toggle('yafa-category__item--dotted', !isActive);
            btn.setAttribute('aria-pressed', String(isActive));
          });
        }

        onInput() {
          window.clearTimeout(this.timer);
          const term = this.input.value.trim();
          if (!term) {
            this.resetResults();
            return;
          }
          this.updateActiveCategoryByTerm(term);
          this.timer = window.setTimeout(() => this.loadResults(term), 180);
        }

        resetResults() {
          this.request?.abort();
          this.products.innerHTML = this.initialMarkup;
          this.products.classList.remove('is-empty');
          this.products.scrollLeft = 0;
          if (this.titleEl) this.titleEl.textContent = this.dataset.featuredTitle || 'Em destaque';
          if (this.status) this.status.textContent = '';
          this.setActiveCategory(null);
          this.buildDots();
        }

        async loadResults(term) {
          const key = term.toLocaleLowerCase();
          if (this.cache.has(key)) {
            this.showResults(this.cache.get(key), term);
            return;
          }

          this.request?.abort();
          this.request = new AbortController();
          const url = new URL(this.dataset.predictiveUrl, window.location.origin);
          url.searchParams.set('q', term);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', this.dataset.resultsLimit || '5');
          url.searchParams.set('section_id', 'predictive-search');

          try {
            const response = await fetch(url, { signal: this.request.signal });
            if (!response.ok) throw new Error('Falha na busca');
            const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
            const cards = Array.from(
              documentResult.querySelectorAll('.rgd-predictive-response__desktop .rgd-search-grid > li')
            );
            const markup = cards
              .map((card) => `<div class="yafa-mobile-search__card">${card.innerHTML}</div>`)
              .join('');
            this.cache.set(key, markup);
            if (term === this.input.value.trim()) this.showResults(markup, term);
          } catch (error) {
            if (error.name !== 'AbortError' && term === this.input.value.trim()) this.showResults('', term);
          }
        }

        showResults(markup, term) {
          if (markup) {
            this.products.innerHTML = markup;
          } else {
            const message = document.createElement('p');
            message.className = 'yafa-mobile-search__empty';
            message.textContent = this.dataset.emptyMessage || 'Nenhum produto encontrado.';
            this.products.replaceChildren(message);
          }
          this.products.classList.toggle('is-empty', !markup);
          this.products.scrollLeft = 0;
          if (this.titleEl) this.titleEl.textContent = `Resultados para “${term}”`;
          if (this.status) this.status.textContent = markup ? 'Produtos encontrados' : this.dataset.emptyMessage;
          this.buildDots();
        }

        buildDots() {
          const cards = Array.from(this.products.querySelectorAll('.yafa-mobile-search__card'));
          const pageCount = Math.ceil(cards.length / 2);
          this.dots.replaceChildren();
          this.dots.hidden = pageCount <= 1;
          const maxScroll = Math.max(0, this.products.scrollWidth - this.products.clientWidth);
          const firstLeft = cards[0]?.offsetLeft || 0;
          this.positions = Array.from({ length: pageCount }, (_, index) => {
            const card = cards[Math.min(index * 2, cards.length - 1)];
            return Math.max(0, Math.min(card.offsetLeft - firstLeft, maxScroll));
          });

          this.positions.forEach((left, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'yafa-mobile-search__dot';
            dot.setAttribute('aria-label', `Ir para a página ${index + 1}`);
            dot.addEventListener('click', () => this.products.scrollTo({ left, behavior: 'smooth' }));
            this.dots.append(dot);
          });
          this.updateDots();
        }

        updateDots() {
          if (!this.positions?.length) return;
          const closest = this.positions.reduce((best, left, index) => {
            return Math.abs(this.products.scrollLeft - left) < Math.abs(this.products.scrollLeft - this.positions[best])
              ? index
              : best;
          }, 0);
          this.dots.querySelectorAll('.yafa-mobile-search__dot').forEach((dot, index) => {
            dot.classList.toggle('is-active', index === closest);
            if (index === closest) dot.setAttribute('aria-current', 'page');
            else dot.removeAttribute('aria-current');
          });
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.request?.abort();
          this.visibilityObserver?.disconnect();
          window.clearTimeout(this.timer);
          cancelAnimationFrame(this.scrollFrame);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yafa-search-mega')) {
    customElements.define(
      'yafa-search-mega',
      class extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('details');
          this.input = this.querySelector('[data-search-input]');
          this.products = this.querySelector('[data-search-products]');
          this.status = this.querySelector('[data-search-status]');
          this.titleEl = this.querySelector('.yafa-search__featured .yafa-search__heading-label > span');
          if (!this.details || !this.input || !this.products) return;

          this.header = this.closest('.header-wrapper') || document.querySelector('.header-wrapper');
          this.initialMarkup = this.products.innerHTML;
          this.cache = new Map();
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };

          ['pointerdown', 'mousedown', 'click', 'focusout'].forEach(evt => {
            this.addEventListener(evt, (e) => e.stopPropagation(), options);
          });

          this.addEventListener('click', (e) => e.stopPropagation(), options);
          this.addEventListener('focusout', (e) => e.stopPropagation(), options);

          this.details.addEventListener(
            'toggle',
            () => {
              if (this.details.open) {
                if (this.header) this.header.preventHide = true;
                document.querySelectorAll('header-menu details[open], details.mega-menu[open]').forEach((other) => {
                  if (other !== this.details) {
                    other.removeAttribute('open');
                    other.querySelector('summary')?.setAttribute('aria-expanded', 'false');
                  }
                });
                setTimeout(() => {
                  this.input.focus();
                }, 50);
              } else {
                if (this.header) this.header.preventHide = false;
              }
            },
            options
          );

          this.input.addEventListener('click', (e) => {
            e.stopPropagation();
            this.input.focus();
          }, options);

          this.querySelector('.yafa-search__form')?.addEventListener('click', (e) => {
            if (!e.target.closest('button')) {
              this.input.focus();
            }
          }, options);

          this.querySelector('.yafa-search__form')?.addEventListener('submit', (e) => {
            e.preventDefault();
            window.clearTimeout(this.timer);
            const term = this.input.value.trim();
            if (!term) {
              this.resetResults();
              return;
            }
            this.updateActiveCategoryByTerm(term);
            this.loadResults(term);
          }, options);

          this.querySelector('[data-search-close]')?.addEventListener('click', () => this.close(), options);
          this.input.addEventListener('input', () => this.onInput(), options);
          this.querySelector('.yafa-search__categories')?.addEventListener(
            'click',
            (event) => this.onSuggestion(event),
            options
          );
          document.addEventListener(
            'click',
            (event) => {
              if (this.details.open && !this.contains(event.target)) this.close();
            },
            options
          );
          document.addEventListener(
            'keydown',
            (event) => {
              if (event.key === 'Escape' && this.details.open) this.close();
            },
            options
          );
        }

        close() {
          this.details.open = false;
          this.input.value = '';
          this.resetResults();
          if (this.header) this.header.preventHide = false;
          this.querySelector('summary')?.focus();
        }

        onSuggestion(event) {
          const category = event.target.closest('[data-search-term]');
          if (!category) return;
          const link = category.dataset.searchLink;
          if (link) {
            window.location.assign(link);
            return;
          }
          const button = category.querySelector('.yafa-category__item');
          this.setActiveCategory(button);
          this.input.value = category.dataset.searchTerm || '';
          this.input.focus();
          this.onInput();
        }

        setActiveCategory(activeButton) {
          this.querySelectorAll('.yafa-search__category .yafa-category__item').forEach((btn) => {
            const isActive = btn === activeButton;
            btn.classList.toggle('yafa-category__item--filled', isActive);
            btn.classList.toggle('yafa-category__item--dotted', !isActive);
            btn.setAttribute('aria-pressed', String(isActive));
          });
        }

        updateActiveCategoryByTerm(term) {
          const lowerTerm = term.toLowerCase();
          this.querySelectorAll('.yafa-search__category').forEach((cat) => {
            const btn = cat.querySelector('.yafa-category__item');
            if (!btn) return;
            const catTerm = (cat.dataset.searchTerm || '').toLowerCase();
            const isActive = catTerm === lowerTerm;
            btn.classList.toggle('yafa-category__item--filled', isActive);
            btn.classList.toggle('yafa-category__item--dotted', !isActive);
            btn.setAttribute('aria-pressed', String(isActive));
          });
        }

        onInput() {
          window.clearTimeout(this.timer);
          const term = this.input.value.trim();
          if (!term) {
            this.resetResults();
            return;
          }
          this.updateActiveCategoryByTerm(term);
          this.timer = window.setTimeout(() => this.loadResults(term), 180);
        }

        resetResults() {
          this.request?.abort();
          this.products.innerHTML = this.initialMarkup;
          if (this.titleEl) this.titleEl.textContent = this.dataset.featuredTitle || 'Em destaque';
          if (this.status) this.status.textContent = '';
          this.setActiveCategory(null);
        }

        async loadResults(term) {
          const key = term.toLocaleLowerCase();
          if (this.cache.has(key)) {
            this.showResults(this.cache.get(key), term);
            return;
          }

          if (this.status) this.status.textContent = 'Buscando...';

          this.request?.abort();
          this.request = new AbortController();
          const url = new URL(this.dataset.predictiveUrl, window.location.origin);
          url.searchParams.set('q', term); 
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', this.dataset.resultsLimit || '5');
          url.searchParams.set('resources[options][prefix]', 'last'); 
          url.searchParams.set('section_id', 'predictive-search');

          try {
            const response = await fetch(url, { signal: this.request.signal });
            if (!response.ok) throw new Error('Falha na busca');
            const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');

            const vzkCards = Array.from(documentResult.querySelectorAll('.vzk-product-card'));
            
            const markup = vzkCards.map((card) => {
              const parentLink = card.closest('a');
              const wrapperToKeep = parentLink ? parentLink : card;
              return `<div class="yafa-search__card">${wrapperToKeep.outerHTML}</div>`;
            }).join('');

            this.cache.set(key, markup);
            if (term === this.input.value.trim()) this.showResults(markup, term);
          } catch (error) {
            if (error.name !== 'AbortError' && term === this.input.value.trim()) this.showResults('', term);
          }
        }
        showResults(markup, term) {
          if (markup) {
            this.products.innerHTML = markup;
          } else {
            const message = document.createElement('p');
            message.className = 'yafa-search__empty';
            message.textContent = this.dataset.emptyMessage || 'Nenhum produto encontrado.';
            this.products.replaceChildren(message);
          }
          if (this.titleEl) this.titleEl.textContent = `Resultados para “${term}”`;
          if (this.status) this.status.textContent = markup ? 'Produtos encontrados' : this.dataset.emptyMessage;
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.request?.abort();
          window.clearTimeout(this.timer);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
